/** @file keyFrame: keys nodes (or the whole pose) at a frame with their current values (clip.keyAll). */
import type { EditorStore } from '../../state/editorTypes';
import { currentClip } from './currentClip';
import { mirrorGuard } from './mirrorGuard';

/**
 * Dispatches `clip.keyAll { clip, frame, nodes? }` on the playhead clip (all nodes when `nodes` is absent); refused
 * with a toast without a clip, with an empty node list, or in a mirrorHalf clip's computed half. Returns whether it sent.
 */
export function keyFrame(store: EditorStore, frame: number, nodes?: string[]): boolean {
  const s = store.getState();
  const cur = currentClip(s);
  if (cur === null) { s.notify('info', 'Pick a clip first'); return false; }
  if (nodes?.length === 0) { s.notify('info', 'Select a node to key'); return false; }
  if (mirrorGuard(cur.clip, frame, s.notify)) return false;
  const input = nodes === undefined ? { clip: cur.name, frame } : { clip: cur.name, frame, nodes };
  void s.dispatch([{ name: 'clip.keyAll', input }], nodes === undefined ? `key all @${frame}` : `key ${nodes.join(', ')} @${frame}`);
  return true;
}
